/* eslint-disable import/no-named-as-default */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';

import Header from '../Header';
import Footer from '../Footer';
import theme, { GlobalStyles } from '../../../themes';

import { Main } from './styles';

const Layout = ({ location, children, cmsTheme, lang, pageId }) => {
  const updatedTheme = cmsTheme
    ? {
        ...theme,
        colors: {
          ...theme.colors,
          ...cmsTheme.colors,
        },
        fonts: {
          ...theme.fonts,
          ...cmsTheme.fonts,
        },
      }
    : theme;

  // store the latest cmsTheme ref we've seen for later comparison
  const cmsThemeCache = useRef(cmsTheme);
  // theme being used by the provider
  const buildTheme = useRef(updatedTheme);

  // if a cmsTheme is provided and it doesn't match the one currently cached
  if (cmsTheme && cmsThemeCache.current !== cmsTheme) {
    cmsThemeCache.current = cmsTheme;
    buildTheme.current = updatedTheme;
  }

  return (
    <ThemeProvider theme={buildTheme.current}>
      <>
        <GlobalStyles />
        <Header location={location} lang={lang} />
        <Main id="content" className={`page-id-${pageId}`}>
          {/* eslint-disable */}
          {process.env.NODE_ENV === 'production' && //this does not appear to work -> we still see gtm on .net
            typeof window !== 'undefined' && (
              <noscript defer>
                <iframe
                  src="https://www.googletagmanager.com/ns.html?id=GTM-T7TSN5K"
                  height="0"
                  width="0"
                  style="display:none;visibility:hidden"
                />
              </noscript>
            )}
          {process.env.NODE_ENV === 'production' &&
            typeof window !== 'undefined' &&
            lang === 'en-in' && (
              /* Load India's GTM container on their version of the website */
              <noscript defer>
                <iframe
                  src="https://www.googletagmanager.com/ns.html?id=GTM-K4F3DTH"
                  height="0"
                  width="0"
                  style="display:none;visibility:hidden"
                />
              </noscript>
            )}
          {/* eslint-enable */}
          {children}
        </Main>
        <Footer lang={lang} />
      </>
    </ThemeProvider>
  );
};

// * StaticQuery Component that retrieves and passes in all the articles
const withStaticQueryRedirect = ({
  children,
  cmsTheme,
  lang,
  pageId,
  location,
}) => {
  return (
    <StaticQuery
      query={graphql`
        query LayoutLocaleMappingQuery {
          prodigy {
            localeMappings {
              path
              locale
            }
          }
        }
      `}
      render={data => (
        <Layout
          data={data}
          cmsTheme={cmsTheme}
          lang={lang}
          pageId={pageId}
          location={location}
        >
          {children}
        </Layout>
      )}
    />
  );
};

withStaticQueryRedirect.propTypes = {
  children: PropTypes.node.isRequired,
  cmsTheme: PropTypes.shape(),
  lang: PropTypes.string,
};

withStaticQueryRedirect.defaultProps = {
  cmsTheme: null,
  lang: 'en-ca',
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  cmsTheme: PropTypes.shape(),
  lang: PropTypes.string,
  pageId: PropTypes.string,
  location: PropTypes.shape(),
};

Layout.defaultProps = {
  cmsTheme: null,
  lang: 'en-ca',
  pageId: 'no-id',
  location: null,
};

export default withStaticQueryRedirect;
